module.exports = __webpack_public_path__ + "static/img/15.c88cc1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/15.png
// module id = /PJ+
// module chunks = 0